import { useTheme } from "@/context/ThemeContext";
import { useLanguage } from "@/context/LanguageContext";
import { supportLabels } from "@/i18n";

export const BeforeBidAndPurchase = () => {
  const { theme } = useTheme();
  const { language } = useLanguage();
  const c = supportLabels(language).docGuideContent?.beforeBidAndPurchase ?? {};
  const isDark = theme === "dark";

  const beforeItems = [c.beforeItem1, c.beforeItem2, c.beforeItem3, c.beforeItem4].filter(
    Boolean
  ) as string[];
  const goodToKnowItems = Array.isArray(c.goodToKnowList)
    ? (c.goodToKnowList as string[])
    : [];
  const platformItems = Array.isArray(c.platformShortList)
    ? (c.platformShortList as string[])
    : [];

  return (
    <div className="space-y-6">
      <div>
        <h4
          className={`font-semibold mb-3 text-base ${
            isDark ? "text-white" : "text-black"
          }`}
        >
          {c.beforeTitle}
        </h4>
        <ul
          className={`text-sm space-y-2 ml-4 ${
            isDark ? "text-gray-300" : "text-gray-700"
          }`}
        >
          {beforeItems.map((item, j) => (
            <li key={j}>• {item}</li>
          ))}
        </ul>
      </div>

      <div>
        <h4
          className={`font-semibold mb-3 text-base ${
            isDark ? "text-white" : "text-black"
          }`}
        >
          {c.goodToKnowTitle}
        </h4>
        <ul
          className={`text-sm space-y-2 ml-4 ${
            isDark ? "text-gray-300" : "text-gray-700"
          }`}
        >
          {goodToKnowItems.map((item, j) => (
            <li key={j}>• {item}</li>
          ))}
        </ul>
      </div>

      <div
        className={`p-4 rounded-lg border ${
          isDark ? "bg-muted/40 border-white/10" : "bg-muted/50 border-black/10"
        }`}
      >
        <h4
          className={`font-semibold mb-1 text-base ${
            isDark ? "text-white" : "text-black"
          }`}
        >
          {c.platformShortTitle}
        </h4>
        {c.platformShortSubtitle && (
          <p
            className={`text-sm italic mb-3 ${
              isDark ? "text-gray-400" : "text-gray-600"
            }`}
          >
            {c.platformShortSubtitle}
          </p>
        )}
        <ul
          className={`text-sm space-y-2 ${
            isDark ? "text-gray-300" : "text-gray-700"
          }`}
        >
          {platformItems.map((item, j) => (
            <li key={j}>• {item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};
